const CHUNK_RECOVERY_KEY = "afrimed:chunk-recovery-attempted:v2";
const CHUNK_RECOVERY_IN_FLIGHT = "__afrimedChunkRecoveryInFlight";

export function isLikelyChunkLoadError(input) {
  const text = String(input || "").toLowerCase();
  if (!text) return false;

  return (
    text.includes("loading chunk") ||
    text.includes("chunkloaderror") ||
    text.includes("failed to fetch dynamically imported module") ||
    text.includes("importing a module script failed")
  );
}

function currentEntryBuildKey() {
  try {
    const entryScript = Array.from(document.querySelectorAll('script[type="module"][src]')).find((script) =>
      /\/assets\/index-/.test(script.src)
    );

    return entryScript?.src || window.location.pathname || "unknown";
  } catch {
    return "unknown";
  }
}

export function recoverFromStaleChunk(reason) {
  if (!isLikelyChunkLoadError(reason) || typeof window === "undefined") return false;

  try {
    if (window[CHUNK_RECOVERY_IN_FLIGHT]) return false;

    const buildKey = currentEntryBuildKey();
    if (sessionStorage.getItem(CHUNK_RECOVERY_KEY) === buildKey) return false;

    sessionStorage.setItem(CHUNK_RECOVERY_KEY, buildKey);
    window[CHUNK_RECOVERY_IN_FLIGHT] = true;

    const next = new URL(window.location.href);
    next.searchParams.set("_af_refresh", String(Date.now()));
    window.location.replace(next.toString());
    return true;
  } catch {
    return false;
  }
}

export function installChunkRecovery() {
  if (typeof window === "undefined") return;

  window.addEventListener("error", (event) => {
    recoverFromStaleChunk(event?.error?.message || event?.message || "");
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event?.reason;
    recoverFromStaleChunk(reason?.message || String(reason || ""));
  });
}
